<script>
import { euroCouponsRequestCouponMethods } from "@state/helpers";
import {
  required,
  maxLength,
  helpers,
  minLength,
  minValue,
  alphaNum,
} from "vuelidate/lib/validators";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import ConfirmModal from "@components/ConfirmModal.vue";

// import EuroCouponsItemForm from '@components/euro_coupons/item/Form'
import XLSX from "xlsx";

const minRequired = (value) => value.length > 0 && value.length <= 150;
const someError = (items) => !items.some((item) => item.error === true);
const mustBeOption = (value) => ["CC", "CE", "PEP", "PPT"].includes(value);
const mustBeYesOrNOT = (value) => [false, true].includes(value);

export default {
  name: "RequestCouponUploadDataInternal",
  components: { DatePicker, ConfirmModal },
  props: {
    fullform: {
      type: Boolean,
      required: false,
      default: false,
    },
    instanceJson: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    type_action: {
      type: String,
      default: "create",
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      submitting: false,
      showConfirmModal: false,
      reading: false,
      action: "create",
      euroCouponsRequestCouponOptions: [],
      selectedFile: false,
      file: null,
      form: {
        url: null,
        // requesting_user: null,
        // cxc: null,
        coupons: [
          // {  quantity: 1, unit_value: 1000 },
          // {  quantity: 2, unit_value: 2000 },
          // {  quantity: 3, unit_value: 1000 },
          // {  quantity: 4, unit_value: 1000 },
        ],
      },
      quantity: null,
      value: null,

      //Table
      fields: [
        {
          key: "document_type",
          label: this.$t("type"),
        },
        {
          key: "document",
          label: this.$t("document"),
        },
        {
          key: "name",
          label: this.$t("name"),
        },
        {
          key: "type_coupon_string",
          label: this.$t("type_coupon_string"),
        },
        // {
        //   key: "euro_employee",
        //   label: this.$t("euro_employee"),
        // },

        // {
        //   key: "agreement",
        //   label: this.$t("agreement"),
        // },
        {
          key: "value",
          label: this.$t("value"),
          formatter: (value) => {
            return this.$formatDollar(value);
          },
        },

        // {
        //   key: 'validity',
        //   label: this.$t('validity'),
        // },
        // {
        //   key: 'expiration_date',
        //   label: this.$t('expiration_date'),
        //   formatter: value => {
        //     return new Date(value).toLocaleDateString("es-CO")
        //   }

        // },
        {
          key: "valid_from",
          label: this.$t("valid_from"),
        },
        {
          key: "expiration_date",
          label: this.$t("expiration_date"),
        },
        {
          key: "actions",
          label: this.$t(""),
        },
      ],
      items: [],

      documentOptions: [
        { value: "CC", text: "CC" },
        { value: "CE", text: "CE" },
        { value: "PEP", text: "PEP" },
        { value: "PPT", text: "PPT" },
      ],
      employeeOptions: [
        { value: false, text: "NO" },
        { value: true, text: "SI" },
      ],
      modelConfig: {
        // type: 'string',
        // mask: 'iso',
        // timeAdjust: '00:00:00',
      },
    };
  },
  validations: {
    form: {
      // items: contains(form.items),
      // requesting_user: { required, },
      // quantity: { required, },
      // value: { required, },
      // cxc: {  },
    },
    items: {
      minRequired,
      someError,
      $each: {
        document_type: {
          required,
          mustBeOption,
        },
        document: {
          required,
          minLength: minLength(6),
        },
        name: {
          required,
          minLength: minLength(4),
        },
        type_coupon_string: {
          required,
          minLength: minLength(4),
        },
        // euro_employee: {
        //   required,
        //   mustBeYesOrNOT,
        // },
        // agreement: {
        //   required,
        //   alphaNum,
        // },
        value: {
          required,
          minValue: minValue(1),
        },
        valid_from: {
          required,
          lessThanExpirationDate: (value, vm) => {
            return value < vm.expiration_date;
          },
        },
        expiration_date: {
          required,
          greaterThanValidFrom: (value, vm) => {
            return value > vm.valid_from;
          },
        },
      },
    },
  },
  computed: {},

  watch: {
    items: {
      deep: true,
      handler(values) {
        values = values.map((item, index) => {
          item["value"] = Number(item["value"]);
          item["index"] = index;
          item["document"] = Number(item["document"]);
          return item;
        });

        this.form.coupons = values;
        this.quantity = values.length;
        this.value = values.reduce((a, b) => a + b["value"], 0);
        this.reading = false;
      },
    },
  },

  mounted: function () {
    let context = this;
    context.form = {
      ...context.form,
      ...context.instanceJson,
    };
    // if (context.instanceJson.url) {
    //   context.action = 'update'
    //   // context.getObject()
    // } else {
    context.action = "create";
    context.loading = false;
    // }
  },

  methods: {
    ...euroCouponsRequestCouponMethods,

    tbodyRowClass(item) {
      return item.error === true ? ["table-danger"] : "";
    },

    processInvalidCoupons(coupons) {
      let context = this;

      coupons.forEach((coupon) => {
        let index = context.items.findIndex((item) => item.index === coupon.index);
        context.items[index]["error"] = coupon.error;
        context.items[index]["errors"] = coupon.errors;
      });

      if (context.type_action === "delete") {
        context.items = context.items.filter((item) => item.error);
      }
    },
    removeItem(index) {
      this.items.splice(index, 1);
      // this.$v.items.$touch()
    },
    toggleError(index) {
      this.items[index].error = !this.items[index].error;
      // this.$v.items.$touch()
    },
    dateFormat(value) {
      return value.toISOString().split("T")[0];
    },

    exportExcel() {
      const sheetToExport = [
        {
          "Tipo de Documento": null, //A
          Documento: null, //B
          Nombre: null, // C
          "Tipo de Bono": null, // D
          Valor: null, //E
          "Fecha Inicio": null, //F
          "Fecha Fin": null, //G
        },
      ];

      const consolidatedWorkSheet = XLSX.utils.json_to_sheet(sheetToExport);

      //Cell comment 'Tipo de Documento'
      consolidatedWorkSheet.A1.c = [];
      consolidatedWorkSheet.A1.c.hidden = true;
      consolidatedWorkSheet.A1.c.push({
        t: "Documentos Validos: CC, CE, PEP, PPT.",
      });

      //Cell comment 'Documento'
      consolidatedWorkSheet.B1.c = [];
      consolidatedWorkSheet.B1.c.hidden = true;
      consolidatedWorkSheet.B1.c.push({
        t: "Por favor solo ingrese números.",
      });

      consolidatedWorkSheet.C1.c = [];
      consolidatedWorkSheet.C1.c.hidden = true;
      consolidatedWorkSheet.C1.c.push({
        t: "Por favor ingrese el nombre",
      });

      //Cell comment 'Tipo Bono'
      consolidatedWorkSheet.D1.c = [];
      consolidatedWorkSheet.D1.c.hidden = true;
      consolidatedWorkSheet.D1.c.push({
        t: "Indique el tipo de bono",
      });

      //Cell comment 'Valor'
      consolidatedWorkSheet.E1.c = [];
      consolidatedWorkSheet.E1.c.hidden = true;
      consolidatedWorkSheet.E1.c.push({
        t: "Por favor solo ingrese números.",
      });

      //Cell comment 'Fecha Inicio'
      consolidatedWorkSheet.F1.c = [];
      consolidatedWorkSheet.F1.c.hidden = true;
      consolidatedWorkSheet.F1.c.push({
        t: 'Por favor Asigne el Formato Fecha a la Columna F "YYYY-MM-DD"',
      });

      //Cell comment 'Fecha Fin'
      consolidatedWorkSheet.G1.c = [];
      consolidatedWorkSheet.G1.c.hidden = true;
      consolidatedWorkSheet.G1.c.push({
        t: 'Por favor Asigne el Formato Fecha a la Columna G "YYYY-MM-DD"',
      });

      const workBook = {
        SheetNames: ["data"],
        Sheets: { data: consolidatedWorkSheet },
      };

      XLSX.writeFile(workBook, "Plantilla Bonos Internos.xlsx");
    },

    readFile() {
      const context = this;
      context.items = [];
      context.reading = true;
      const fileReader = new FileReader();

      const readOpts = {
        // <--- need these settings in readFile options
        // cellText:false,
        cellDates: true,
        type: "binary",
      };

      const jsonOpts = {
        // header: 1,
        // defval: '',
        // blankrows: true,
        raw: false,
        cellNF: true,
        // dateNF: 'd"/"m"/"Y' // <--- need dateNF in sheet_to_json options (note the escape chars)
      };

      // this.importingData = true
      fileReader.onload = async (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, readOpts);

          const wsname = workbook.SheetNames[0];
          let ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], jsonOpts);

          if (ws.length >= 151) {
            context.reading = false;
            return this.$generate_toast(
              context,
              "error",
              "Demasiados registros, por favor realice cargas de máximo 150 bonos."
            );
          }

          if (ws.length === 0) {
            context.reading = false;
            return this.$generate_toast(context, "error", "No hay información");
          }
          // let coupons = []
          // workbook.SheetNames.forEach((sheetname, index) => {
          //   context.items = XLSX.utils.sheet_to_json(
          //     workbook.Sheets[sheetname],
          //     { raw: false, cellNF: true }
          //   )
          // })

          let tmp_items = [];
          ws.forEach((coupon, index) => {
            // let is_employee = coupon["Empleado Euro"].toUpperCase();
            // if (is_employee === "SI") {
            //   is_employee = true;
            // } else if (is_employee === "NO") {
            //   is_employee = false;
            // } else {
            //   is_employee = "";
            // }

            let item = {
              document_type: coupon["Tipo de Documento"].toUpperCase(),
              document: Number(coupon["Documento"]),
              name: coupon["Nombre"],
              type_coupon_string: coupon["Tipo de Bono"].toUpperCase(),
              value: Number(coupon["Valor"]),
              euro_employee: true,
              valid_from: new Date(coupon["Fecha Inicio"] + " 00:00"),
              expiration_date: new Date(coupon["Fecha Fin"] + " 00:00"),
              index: index,
              error: false,
            };
            tmp_items.push(item);
          });
          context.items = [...tmp_items];
        } catch (e) {
          // context.importingData = false
          // context.submitting = false
          // context.resetData()
          console.log(e);
          context.reading = false;
          return this.$generate_toast(context, "error", "Error al leer archivo");
        }
      };
      fileReader.readAsBinaryString(context.file);
    },

    importExcel(e) {
      const context = this;
      const files = e.target.files;
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        return context.$generate_toast(
          context,
          "error",
          "Seleccionar un archivo con formato xls o xlsx"
        );
      }
      context.file = files[0];
      context.selectedFile = true;
      // this.readFile(files[0])
    },

    // getObject() {
    //   let context = this
    //   if (context.action == 'update') {
    //     const promise = context.fetchEuroCouponsRequestCouponDetail(
    //       context.form.url
    //     )
    //     return promise
    //       .then((data) => {
    //         context.form = { ...data }
    //         context.loading = false
    //       })
    //       .catch((error) => {
    //         context.$axios_error_noty(error, context)
    //         context.loading = false
    //       })
    //   }
    // },

    submit() {
      let context = this;
      context.submitting = true;
      let actions = {
        create: context.manualCreateInternalEuroCouponsRequestCoupon,
        delete: context.manualDeleteInternalEuroCouponsRequestCoupon,
      };
      const promise = actions[context.type_action](context.form);
      return promise
        .then((response) => {
          let data = response;
          if (response.status !== 206) {
            context.$generate_toast(
              context,
              "success",
              `${context.$t("request_coupon")} ${context.$t("created")} ${context.$t(
                "correctly"
              )}`
            );
            setTimeout(() => {
              context.oncomplete(data.url || null);
              context.submitting = false;
              context.showConfirmModal = false;
            }, 2000);
          } else {
            context.$generate_toast(
              context,
              "info",
              `Algunos cupones no fueron encontrados.`
            );
            context.processInvalidCoupons(response.data.coupons);
            context.submitting = false;
            context.showConfirmModal = false;
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.request.response);
          let dataTemp = JSON.parse(error.request.response);
          console.log(dataTemp);
          for (let erro of dataTemp.coupons) {
            if (erro.errors.includes("overlapping_coupons")) {
              console.log("entro aqui");
              context.$generate_toast(
                context,
                "error",
                "Estas tratando de crear cupones que ya existen"
              );
            }
          }
          context.submitting = false;
          context.showConfirmModal = false;
          if (error.response.data.coupons) {
            context.processInvalidCoupons(error.response.data.coupons);
            delete error.response.data["coupons"];
          }
          context.$axios_error_noty(error, context);
        });
    },

    errorMessage(errors = []) {
      let context = this;
      let listFields = errors.map((error) => context.$t(error)).join(", ");
      let create_message =
        "El beneficiario actualmente posee bonos asociados en los rangos de tiempo especificados.";
      let delete_message = "No se encontró bono con la información especificada.";

      if (errors[0] === "overlapping_coupons" && context.type_action == "create") {
        return create_message;
      } else if (context.type_action == "delete") {
        delete_message;
      }
      return `Los siguientes campos poseen datos inválidos: ${listFields}. `;
    },

    confirmSubmit() {
      let context = this;
      context.$v.form.$touch();
      context.$v.items.$touch();
      console.log("validacion");
      console.log(this.items);

      if (context.$v.form.$invalid || context.$v.items.$invalid) {
        context.submitting = false;
        context.$generate_toast(context, "error", context.$t("fill_the_required_fields"));
        return;
      }
      context.showConfirmModal = true;
    },
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    scrollable
    id="upload-data-modal"
    :title="
      type_action === 'create'
        ? `${$t('create')} ${$t('request_coupons')} internos`
        : `${$t('delete')} ${$t('coupons')} internos`
    "
    :size="action === 'create' ? 'xl' : 'xl'"
    @hidden="oncancel"
    @ok.prevent="confirmSubmit"
  >
    <div class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else class="m-3">
        <b-col md="12">
          <div class="mb-3">
            <b-form-group
              class="text-primary font-weight-bold"
              :label="$t('upload_data_from_file')"
            >
              <b-form-file
                class="border-primary"
                ref="excel_user_file"
                :placeholder="$t('select_file')"
                :drop-placeholder="$t('select_file')"
                :browse-text="$t('search')"
                @change="importExcel"
              />
            </b-form-group>
            <b-button variant="secondary rounded" class="mr-2" @click="exportExcel">
              <i class="fas fa-file-excel"></i>
              {{ $t("download_template") }}
            </b-button>
            <b-button
              variant="primary rounded"
              :disabled="!selectedFile || submitting || reading"
              @click="readFile"
            >
              <b-spinner v-if="reading" label="Spinning" small></b-spinner>
              <i v-else class="fas fa-file-import"></i>
              <span> {{ reading ? "Procesando" : $t("process_file") }} </span>
            </b-button>
          </div>
        </b-col>
        <b-col class="mt-3">
          <div>
            <!-- <pre>{{ items  }}</pre> -->
            <h5>Vista previa bonos asociados a beneficiarios</h5>

            <div
              v-if="!$v.items.someError && $v.items.minRequired"
              class="alert alert-danger"
              role="alert"
            >
              {{
                type_action === "create"
                  ? "Los beneficiarios resaltados actualmente poseen datos inconsistentes"
                  : "Los bonos resaltados no fueron encontrados"
              }}
              <span class="alert-link"
                >actualice la información y verifique o elimínelos.</span
              >
            </div>

            <b-table
              v-if="items.length"
              hover
              small
              :items="items"
              :fields="fields"
              responsive
              :thead-class="['text-primary', 'border-primary']"
              :tbody-tr-class="tbodyRowClass"
            >
              <template #cell(total)="row">
                {{ row.item.unit_value * row.item.quantity }}
              </template>

              <template #cell(name)="row">
                <b-form-input
                  size="sm"
                  type="text"
                  v-model="row.item.name"
                  autocomplete="off"
                  :readonly="false"
                  v-b-tooltip.focus="{
                    variant: $v.items.$each[row.index].name.$invalid
                      ? 'danger'
                      : 'success',
                  }"
                  :title="
                    $v.items.$each[row.index].name.$invalid
                      ? 'Campo obligatorio, Mínimo 3 caracteres'
                      : 'campo valido'
                  "
                  :state="!$v.items.$each[row.index].name.$invalid"
                />
              </template>
              <template #cell(agreement)="row">
                <b-form-input
                  type="text"
                  v-model="row.item.agreement"
                  size="sm"
                  :state="!$v.items.$each[row.index].agreement.$invalid"
                  v-b-tooltip.focus="{
                    variant: $v.items.$each[row.index].agreement.$invalid
                      ? 'danger'
                      : 'success',
                  }"
                  :title="
                    $v.items.$each[row.index].agreement.$invalid
                      ? 'Solo ingrese valores alfanuméricos'
                      : 'campo valido'
                  "
                />
              </template>
              <template #cell(document_type)="row">
                <b-form-select
                  style="min-width: 80px"
                  v-model="row.item.document_type"
                  :options="documentOptions"
                  :state="!$v.items.$each[row.index].document_type.$invalid"
                  v-b-tooltip.focus="{
                    variant: $v.items.$each[row.index].document_type.$invalid
                      ? 'danger'
                      : 'success',
                  }"
                  :title="
                    $v.items.$each[row.index].document_type.$invalid
                      ? 'Seleccione una opción valida'
                      : 'campo valido'
                  "
                >
                </b-form-select>
              </template>
              <template #cell(document)="row">
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="row.item.document"
                  :formatter="(value) => Number(value)"
                  :state="!$v.items.$each[row.index].document.$invalid"
                  v-b-tooltip.focus="{
                    variant: $v.items.$each[row.index].document.$invalid
                      ? 'danger'
                      : 'success',
                  }"
                  :title="
                    $v.items.$each[row.index].document.$invalid
                      ? 'Obligatorio, debe tener mínimo 6 dígitos.'
                      : 'campo valido'
                  "
                />
              </template>
              <template #cell(euro_employee)="row">
                <b-form-select
                  style="min-width: 80px"
                  v-model="row.item.euro_employee"
                  :options="employeeOptions"
                  :state="!$v.items.$each[row.index].euro_employee.$invalid"
                  v-b-tooltip.focus="{
                    variant: $v.items.$each[row.index].euro_employee.$invalid
                      ? 'danger'
                      : 'success',
                  }"
                  :title="
                    $v.items.$each[row.index].euro_employee.$invalid
                      ? 'Seleccione una opción valida'
                      : 'campo valido'
                  "
                >
                </b-form-select>
              </template>
              <template #cell(value)="row">
                <b-form-input
                  size="sm"
                  type="number"
                  :formatter="(value) => Number(value)"
                  v-model="row.item.value"
                  :state="!$v.items.$each[row.index].value.$invalid"
                  v-b-tooltip.focus="{
                    variant: $v.items.$each[row.index].value.$invalid
                      ? 'danger'
                      : 'success',
                  }"
                  :title="
                    $v.items.$each[row.index].value.$invalid
                      ? 'Debe ser superior a 1'
                      : 'campo valido'
                  "
                />
              </template>
              <template #cell(valid_from)="row">
                <DatePicker
                  mode="date"
                  :model-config="modelConfig"
                  v-model="row.item.valid_from"
                >
                  <template v-slot="{ inputValue, togglePopover }">
                    <b-form-input
                      size="sm"
                      readonly
                      :value="inputValue"
                      @click="togglePopover()"
                      :state="!$v.items.$each[row.index].valid_from.$invalid"
                      v-b-tooltip.focus="{
                        variant: $v.items.$each[row.index].valid_from.$invalid
                          ? 'danger'
                          : 'success',
                        placement: 'left',
                      }"
                      :title="
                        $v.items.$each[row.index].valid_from.$invalid
                          ? 'La fecha debe ser inferior a la de expiración'
                          : 'campo valido'
                      "
                    />
                  </template>
                </DatePicker>
              </template>
              <template #cell(expiration_date)="row">
                <DatePicker
                  mode="date"
                  :model-config="modelConfig"
                  :input-debounce="500"
                  v-model="row.item.expiration_date"
                >
                  <template v-slot="{ inputValue, togglePopover }">
                    <b-form-input
                      size="sm"
                      readonly
                      :value="inputValue"
                      @click="togglePopover()"
                      :state="!$v.items.$each[row.index].expiration_date.$invalid"
                      v-b-tooltip.focus="{
                        variant: $v.items.$each[row.index].expiration_date.$invalid
                          ? 'danger'
                          : 'success',
                        placement: 'left',
                      }"
                      :title="
                        $v.items.$each[row.index].expiration_date.$invalid
                          ? 'La fecha debe ser superior a la de inicio.'
                          : 'campo valido'
                      "
                    />
                  </template>
                </DatePicker>
              </template>
              <template #cell(actions)="row">
                <div style="min-width: 75px">
                  <b-button
                    :id="`delete-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'danger',
                      placement: 'leftbottom',
                      title: $t('delete'),
                    }"
                    variant="btn-link text-danger btn-transparent"
                    @click="
                      () => {
                        removeItem(row.index);
                      }
                    "
                  >
                    <i class="far fa-trash-alt"></i>
                  </b-button>
                  <b-button
                    v-if="row.item.errors && row.item.error"
                    :id="`info-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'danger',
                      placement: 'leftbottom',
                      title: errorMessage(row.item.errors),
                    }"
                    variant="btn-link text-danger btn-transparent mx-1"
                  >
                    <i class="fas fa-exclamation-circle"></i>
                  </b-button>
                  <b-button
                    v-if="row.item.error"
                    :id="`check-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'success',
                      placement: 'top',
                      title: 'De clic para indicar que el registro fue corregido.',
                    }"
                    variant="btn-link text-success btn-transparent"
                    @click="
                      () => {
                        toggleError(row.index);
                      }
                    "
                  >
                    <i class="far fa-calendar-check"></i>
                  </b-button>
                </div>
              </template>
              <template #custom-foot>
                <b-tr>
                  <b-td
                    colspan="3"
                    class="text-primary font-weight-bold text-right"
                    style="border-top: solid 1px"
                    ><span>Total</span></b-td
                  >
                  <b-td
                    class="border-primary text-center"
                    style="border-top: solid 1px"
                    >{{ $formatDollar(quantity) }}</b-td
                  >
                  <b-td
                    class="border-primary text-center"
                    style="border-top: solid 1px"
                    >{{ $formatDollar(value) }}</b-td
                  >
                </b-tr>
              </template>
            </b-table>
          </div>
          <div v-if="!$v.items.minRequired" class="alert alert-danger" role="alert">
            La solicitud debe tener
            <span class="alert-link"> al menos un bono y máximo 150</span>.
          </div>
        </b-col>
      </b-row>
    </div>

    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="outline-primary" class="rounded-lg" @click="cancel">
        Cancelar
      </b-button>

      <b-button
        :variant="type_action === 'create' ? 'primary' : 'danger'"
        class="rounded-lg"
        :disabled="!$v.items.minRequired"
        :class="{ disabled: submitting }"
        @click="ok"
      >
        <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
        <span v-if="submitting">
          {{ type_action === "create" ? $t("saving") : $t("deleting") }}
        </span>
        <span v-else>
          <i
            :class="{
              'fe-save': type_action === 'create',
              'far fa-trash-alt': type_action === 'delete',
            }"
          ></i>
          {{ type_action === "create" ? $t("create") : $t("delete") }}
        </span>
      </b-button>
    </template>
    <ConfirmModal
      v-if="showConfirmModal"
      :close-modal="
        () => {
          showConfirmModal = false;
        }
      "
      :on-submit="submit"
      :submitting="submitting"
      :warningMessage="`¿Esta seguro de ${
        type_action === 'create' ? $t('create') : $t('delete')
      } los bonos con la información indicada?`"
    />
  </b-modal>
</template>
<style lang="scss">
#upload-data-modal .modal-dialog {
  max-width: 95%;
  // margin: 0;
  // top: 0;
  // bottom: 0;
  // left: 0;
  // right: 0;
  height: 95vh;
  display: flex;
}
</style>
